import Debug from "debug";
const debug = Debug("model:actions:eat");

const FOOD_LOW_WARNING = 50;

const notification =
  (foodLeft) => (foodLeft <= FOOD_LOW_WARNING ? `food is running low` : null);

const attempt = ({ party: { caravan, resources } }) => {
  const foodNeeded = caravan.eat();
  const foodAvailable = resources.attribs.food.value;

  const success = foodNeeded <= foodAvailable;
  const healthPenalty = calculateHealthPenalty(foodNeeded, foodAvailable);

  const result = {
    success,
    cost: {
      food: Math.min(foodAvailable, foodNeeded),
      health: healthPenalty,
    },
  };

  debug(result.success, foodAvailable, foodNeeded);

  return result;
};

const executeSideEffects = (context, result) => {
  const { history, resources } = context.party;
  const { cost } = result;

  // Track action
  history.add({ action: "eat", result });

  resources.delta({ food: -cost.food, health: -cost.health }, context);

  // Optionally update party status or trigger events based on food shortage
  handleFoodShortageEffects(context, result.success);

  return { notification: notification(resources.attribs.food.value) };
};

function calculateHealthPenalty(foodNeeded, foodAvailable) {
  const shortfall = foodNeeded - foodAvailable;

  // penalty calculation: 1 health point for every 2 units of food missing
  const penalty = Math.max(0, Math.ceil(shortfall / 2));

  return penalty;
}

/**
 * Handles the broader effects of food shortage on the party.
 */
function handleFoodShortageEffects(context, hadEnoughFood) {
  const { party } = context;

  if (!hadEnoughFood) {
    // Reduce morale for each day without enough food
    //party.morale -= 5; // Assuming a morale property exists and is measured out of 100

    // Increase chance of sickness
    if (Math.random() < 0.1) {
      // 10% chance
      // party.addCondition("sickness"); // Assuming a method exists to add conditions or ailments
    }

    // Trigger specific story or dialogue events related to food scarcity
    if (party.morale < 50) {
      // Trigger a low morale event, dialogue, or decision
      //party.triggerEvent("lowMoraleDueToHunger"); // Assuming a method exists to trigger in-game events
    }
  } else {
    // Possible positive effects of having enough food
    if (party.morale < 100) {
      //party.morale += 2; // Slow morale recovery when food is sufficient
    }
  }

  // Adjust effects based on party's current state, such as existing conditions or story progression
}

// Only enable the action if food is a visible resource
const enabled = ({ party: { resources, phase } }) =>
  resources.isVisible(phase, resources.attribs.food);

const eat = {
  title: "Daily Rations", // for clarity, even if not user-triggered
  enabled,
  execute: (context) => {
    if (!enabled(context)) {
      debug("Eat action is not enabled");
      return null;
    }

    const result = attempt(context);
    const { notification } = executeSideEffects(context, result);

    return { success: result.success, notification };
  },
};

export default eat;
